// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import firebase from "firebase/compat/app";
import { getFirestore, getDocs, collection, getDoc, doc } from "firebase/firestore";
import {getAuth, GoogleAuthProvider, signInWithPopup, signOut} from "firebase/auth";
import {getStorage} from "firebase/storage"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAVs2hnjXfnZXkyZQugkjOr6tF8i5g-Syo",
    authDomain: "disney-plus-3e724.firebaseapp.com",
    projectId: "disney-plus-3e724",
    storageBucket: "disney-plus-3e724.appspot.com",
    messagingSenderId: "523234591050",
    appId: "1:523234591050:web:f9125e271d727b568b81b3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app)
const provider = new GoogleAuthProvider()

// const app = firebase.initializeApp(firebaseConfig);
// const db = app.firestore();
// const auth = firebase.auth();
// const provider = new firebase.auth.GoogleAuthProvider()
// const storage = firebase.storage();

export {auth, provider, storage, getDocs, collection, signInWithPopup, signOut, getDoc, doc}
export default db;